import React, { useState } from 'react';
import { GetStaticPropsContext } from "next";
import 'rc-slider/assets/index.css';
import { withAppLayout } from "components/core/withAppLayout";
import { createSubscription } from "components/hooks/usePreview";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
import { HeaderQuery } from "queries/Header";
import { FooterQuery } from "queries/Footer";
import Container from "components/core/Container";
import Script from "next/script";
import getConfig from "next/config";
import Heading from "components/elements/Heading";
import { useRouter } from "next/router";
import { request } from "components/hooks/useQuery";
import { getAllPageSlugs } from "queries/Page";
import useScript from "react-script-hook";
const { publicRuntimeConfig } = getConfig();

export async function getStaticProps(context: GetStaticPropsContext) {
    const query = {
        query: {
            ...HeaderQuery(context.locale),
            ...FooterQuery(context.locale)
        },
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    const data = await createSubscription(context, query);

    return {
        props: {
            data: data,
            appData: {
                ...data.initialData.header,
                ...data.initialData.footer,
            },
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        }
    };
}

function Index(props: any) {
    const isProd = publicRuntimeConfig.ENV === "production";
    // const [widgetId, setWidgetId] = useState("");
    //
    // const getScript = (id: string) => {
    //     return (
    //         <Script
    //             src={isProd ? "https://widget.piggy.eu/widget.js" : "https://widget.piggyloyalty.nl/widget.js" }
    //             strategy="beforeInteractive"
    //             id="piggy-widget"
    //             data-widget-id={isProd ? "603" : "33"}
    //             data-widget-debug="enabled"
    //         />
    //     );
    // };

    return (
        <>
            <Script
                src={isProd ? "https://widget.piggy.eu/widget.js" : "https://widget.piggyloyalty.nl/widget.js" }
                strategy="beforeInteractive"
                id="piggy-widget"
                data-widget-id={isProd ? "603" : "33"}
                data-widget-debug="enabled"
            />
            {/*{widgetId && getScript(widgetId)}*/}
            <Container className={"mt-8 h-[32rem] pt-20"}>
                <Heading renderAs={"h1"}>
                    Widget demo page
                </Heading>
                {/*<input defaultValue={widgetId} onBlur={(event) => setWidgetId(event.target.value)}/>*/}
            </Container>
        </>
    );
}

export default withAppLayout(Index);